export interface ICompanyEmployeeState {
  getAllCompanyEmployesSuccess: any;
  getAllCompanyEmployesError: any;
  getAllCompanyEmployesInProgress: boolean;
  getAllCompanyEmployesByRolesSuccess: any;
  getAllCompanyEmployesByRolesError: any;
  getAddCompanyEmployeeSuccess: any;
  getAddCompanyEmployeeError: any;
  getEditCompanyEmployeeSuccess: any;
  getEditCompanyEmployeeError: any;
  getLoginCompanyEmployeeSuccess: any;
  getLoginCompanyEmployeeError: any;
  sendLinkComapanyEmployeeFrgtPswdSuccess: any;
  sendLinkComapanyEmployeeFrgtPswdError: any;
  getComapanyEmployeeFrgtresetPasswordSuccess: any;
  getComapanyEmployeeFrgtresetPasswordError: any;
  getEmployeesToAddMasterUserSuccess: any;
  setCompanyEmployeesErrorMsg: any;
  getRemoveCmpyUsersSuccess: any;
  getRemoveCmpyUsersError: any;
  getEmployeesToAddSubUserSuccess: any;
  getEmployeesToAddSubUserError: any;
  getRemoveUserRolesSuccess: any;
  getRemoveUserRolesError: any;
  //userRole
  getRoleUserSuccess: any;
  getRoleUserError: any;
  getAllSalesControllerUsersSuccess: any;
  getAllSalesControllerUsersError: any;
  getAllWarehouseControllerUsersSuccess: any;
  getAllWarehouseControllerUsersError: any;

  getAllwarehouseandproductionUsersSuccess: any;
  getAllwarehouseandproductionUsersError: any;
}

export const initialCompanyEmployeeState: ICompanyEmployeeState = {
  getAllCompanyEmployesSuccess: null,
  getAllCompanyEmployesError: null,
  getAllCompanyEmployesInProgress: false,
  getAllCompanyEmployesByRolesSuccess: null,
  getAllCompanyEmployesByRolesError: null,
  getAddCompanyEmployeeSuccess: null,
  getAddCompanyEmployeeError: null,
  getEditCompanyEmployeeSuccess: null,
  getEditCompanyEmployeeError: null,
  getLoginCompanyEmployeeSuccess: JSON.parse(sessionStorage.getItem('userDetails')),
  getLoginCompanyEmployeeError: null,
  sendLinkComapanyEmployeeFrgtPswdSuccess: null,
  sendLinkComapanyEmployeeFrgtPswdError: null,
  getComapanyEmployeeFrgtresetPasswordSuccess: null,
  getComapanyEmployeeFrgtresetPasswordError: null,
  getEmployeesToAddMasterUserSuccess: null,
  setCompanyEmployeesErrorMsg: null,
  getRemoveCmpyUsersSuccess: null,
  getRemoveCmpyUsersError: null,
  getEmployeesToAddSubUserSuccess: null,
  getEmployeesToAddSubUserError: null,
  getRemoveUserRolesSuccess: null,
  getRemoveUserRolesError: null,

  getRoleUserSuccess: null,
  getRoleUserError: null,

  getAllSalesControllerUsersSuccess: null,
  getAllSalesControllerUsersError: null,
  getAllWarehouseControllerUsersSuccess: null,
  getAllWarehouseControllerUsersError: null,

  getAllwarehouseandproductionUsersSuccess: null,
  getAllwarehouseandproductionUsersError: null,
};
